import React from 'react';
import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {UsefulLinksListComponent} from './parts/useful-links-list/useful-links-list.component';
import {UserMenuTitleBox} from "../user-menu/user-menu/boxes/user-menu-title.box";
import {UsefulLinksSectionBox} from "./boxes/useful-links-section.box";
import {LogOutSectionBox} from "./boxes/log-out/log-out-section.box";
import {UsefulLinksSectionIconBox} from "./boxes/useful-links-section-icon.box";
import { LogOutLinkBox } from './boxes/log-out/log-out-link.box';
import {CyClass} from '../../../common/cy-classes';

@observer
export class UsefulLinks extends OrbitComponent<{}> {
  render() {
    const translator = this.services.translation;
    const userMenuService = this.services.userMenu;

    return (<div>
      <UsefulLinksSectionBox className={CyClass('cy-useful-links-section')}>
        <UsefulLinksSectionIconBox />
        <UserMenuTitleBox>
          {translator.translate("USEFUL_LINKS")}
        </UserMenuTitleBox>
        <UsefulLinksListComponent/>
      </UsefulLinksSectionBox>

      {/*we separate the logout from sdk usefulLinks do to design requirements*/}
      <LogOutSectionBox className={CyClass('cy-useful-links-section')}>
        <LogOutLinkBox className={`${CyClass('cy-logout-link')} ${CyClass('cy-useful-links-item')}`} onClick={() => userMenuService.doLogout()}>
          {translator.translate("LOGOUT")}
        </LogOutLinkBox>
      </LogOutSectionBox>
    </div>);
  }

}
